module.exports = __webpack_public_path__ + "static/media/main4.506c8ebb.jpeg";